import { useState, useEffect, useCallback } from 'react'
import { db } from '../lib/supabase'

export function useDocuments() {
  const [documents, setDocuments] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const fetchDocuments = useCallback(async () => {
    setLoading(true)
    const { data, error } = await db.getDocuments()
    if (error) {
      setError(error)
    } else {
      setDocuments(data)
    }
    setLoading(false)
  }, [])

  useEffect(() => {
    fetchDocuments()
  }, [fetchDocuments])

  const createDocument = async (document) => {
    const { data, error } = await db.createDocument(document)
    if (!error && data) {
      setDocuments(prev => [data, ...prev])
    }
    return { data, error }
  }

  return {
    documents,
    loading,
    error,
    refetch: fetchDocuments,
    createDocument,
  }
}

export default useDocuments
